import axios from "axios";
import encryptionInterceptor from "./encryption/encryptionInterceptor";
import { getAcceptLanguage } from "./acceptLanguage";

/**
 * API Client - Axios instance مشترك مع التشفير التلقائي
 * يستخدم في جميع الطلبات بدلاً من axios المباشر
 */
const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
  },
});

// إضافة Request Interceptor لإضافة Authorization + Accept-Language تلقائياً
apiClient.interceptors.request.use(
  (config) => {
    config.headers = config.headers || {};

    // Always send Accept-Language: ar | en on every API call
    config.headers["Accept-Language"] = getAcceptLanguage();

    // التحقق من وجود متغير isAuthorized في config
    // إذا كان false أو غير موجود، لا نضيف التوكن
    const isAuthorized = config.isAuthorized !== false; // افتراضياً true

    if (isAuthorized) {
      const token = sessionStorage.getItem("ecoToken");
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }

    // إزالة isAuthorized من config قبل الإرسال (لأنه خاص بالعميل فقط)
    delete config.isAuthorized;

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// إضافة Response Interceptor لمعالجة الأخطاء العامة
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    // معالجة أخطاء 401 (غير مصرح)
    if (error.response?.status === 401) {
      // يمكن إضافة منطق refresh token هنا إذا لزم الأمر
    }
    return Promise.reject(error);
  }
);

// إعداد نظام التشفير
encryptionInterceptor.setup(apiClient);

export default apiClient;
